/**
 * Platform web-view / iframe 嵌入：?embed=1 写入 sessionStorage，SPA 内跳转仍保留嵌入态。
 * hideChrome：embed=1（持久）或在 iframe 中打开（与 Platform 规划一致）。
 */
var STORAGE_KEY = 'ebk_embed'

export function syncEmbedFlagFromRoute(route) {
  if (typeof window === 'undefined' || !route || !route.query) return
  var q = route.query.embed
  if (q === '1' || q === true || q === 'true') {
    window.sessionStorage.setItem(STORAGE_KEY, '1')
  } else if (q === '0' || q === false || q === 'false') {
    window.sessionStorage.removeItem(STORAGE_KEY)
  }
}

export function isEmbedFlagStored() {
  if (typeof sessionStorage === 'undefined') return false
  return sessionStorage.getItem(STORAGE_KEY) === '1'
}

export function isInIframe() {
  try {
    return window.self !== window.top
  } catch (e) {
    return true
  }
}

/** 顶栏/侧栏/底栏是否隐藏（仅内容区） */
export function shouldHideAppChrome() {
  return isEmbedFlagStored() || isInIframe()
}



// WEBPACK FOOTER //
// ./src/utils/embed.js